import { initProductBuyTile } from '../../../snippets/product-buy-tile-control/product-buy-tile-control';

export const initRefurbishedControlsSectionTiles = () => {
  const controlProductEls = document.querySelectorAll(
    '[data-list-collections-refurbished-controls-product]'
  );

  controlProductEls.forEach((productEl) => {
    const productId = productEl.getAttribute(
      'data-list-collections-refurbished-controls-product'
    );

    if (productId) {
      initProductBuyTile(productId);
    }
  });
};
